import React, { FC, ReactNode } from 'react'
import { Stack, StackProps } from '@chakra-ui/react'

export type IndentProps = {
  children: ReactNode
} & StackProps

export const Indent: FC<IndentProps> = ({ children, ...props }) => (
  <Stack
    spacing="xl"
    alignItems="stretch"
    direction="column"
    p="lg"
    bg="softWhite"
    {...props}
  >
    {children}
  </Stack>
)
